import ReactECharts from "echarts-for-react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { InsightsAdvancedPayload } from "../../commonTypes/insightAdvancedTypes";
import SkeltonElement from "../../components/commons/SkeltonLoader/SkeltonElement";
import //   resetInsightAdvancedFetching,

//   resetInsightAdvancedListData,
"../../redux/insightsAdvanced";
import { resetTotalExpenses } from "../../redux/insightsAdvanced";
import { getInsightsAdvancedExpenseAction } from "../../redux/insightsAdvanced/actions";
import { RootState } from "../../redux/rootReducers";
import { getLastFiveFinancialYears } from "../../utils/commonFunctions";

type AppProps = {
  token: string | null;
  client_code: number | null;
  history: any;
  fetching: boolean;
  totelExpense: any;
  dispatchInsightsAdvancedExpenseListData: (
    data: InsightsAdvancedPayload
  ) => void;
  dispatchResetTotalExpenses: () => void;
  company_name: string | undefined;
  currency: string | undefined;
};

const TotalExpense = ({
  token,
  client_code,
  history,
  fetching,
  dispatchInsightsAdvancedExpenseListData,
  totelExpense,
  dispatchResetTotalExpenses,
  company_name,
  currency,
}: AppProps) => {
  const [monthList, setMonthList] = useState([]);
  const [currentData, setCurrentData] = useState([]);
  const [previousData, setPreviousData] = useState([]);

  useEffect(() => {
    dispatchResetTotalExpenses();
    if (token && client_code) {
      let final_data = {
        token,
        client_code,
        type: "expenses",
        start_FY: getLastFiveFinancialYears()[1]?.value,
        end_FY: getLastFiveFinancialYears()[0]?.value,
      };
      dispatchInsightsAdvancedExpenseListData(final_data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (totelExpense?.length) {
      const monthData = totelExpense[
        totelExpense?.length - 1
      ]?.prev_year_monthly_data?.map(function (item: any) {
        return item.month;
      });

      setMonthList(monthData);

      const currentYearData = totelExpense[
        totelExpense?.length - 1
      ]?.current_year_monthly_data?.map(function (item: any) {
        return item.total_amount;
      });

      setCurrentData(currentYearData);

      const previousYearData = totelExpense[
        totelExpense?.length - 1
      ]?.prev_year_monthly_data?.map(function (item: any) {
        return item.total_amount;
      });
      setPreviousData(previousYearData);
    }
  }, [totelExpense]);

  const option = {
    visualMap: [
      {
        show: false,
        type: "continuous",
      },
    ],

    tooltip: {
      trigger: "axis",
    },

    grid: {
      bottom: "20%",
      left: currentData && Math.max(...currentData) > 150000 ? "15%" : "12%",
      right: "5%",
    },
    xAxis: [
      {
        data: monthList?.length === 0 ? [] : monthList,

        boundaryGap: false,
        nameLocation: "middle",
        nameTextStyle: {
          width: 100,
          color: "#4e4b66",
          fontSize: "14px",
        },
        nameGap: 30,
      },
    ],

    yAxis: [
      {
        type: "value",
        axisLabel: {
          formatter: `${currency}{value}`,
        },

        nameLocation: "middle",
        nameTextStyle: {
          color: "#4e4b66",
          fontSize: "14px",
          fontFamily: "Poppins",
        },
        nameGap: 15,
      },
    ],

    series: [
      {
        name: "current",
        type: "line",

        symbol: "none",
        smooth: 0.2,
        lineStyle: {
          color: "#e7733e",
          width: 2.5,
        },
        areaStyle: {
          opacity: 0.2,
          color: "#e7733e",
        },

        data: currentData?.length === 0 ? [] : currentData,
      },
      {
        name: "previous",
        type: "line",
        smooth: 0.2,
        symbol: "none",
        lineStyle: {
          color: "#7c8db0",
          width: 2.5,
        },
        areaStyle: {
          opacity: 0.2,
          color: "#7c8db0",
        },
        data: previousData?.length === 0 ? [] : previousData,
      },
    ],
  };

  return (
    <>
      {fetching ? (
        <SkeltonElement type="XXLavatar" />
      ) : (
        <>
          {totelExpense?.length ? (
            <div
              style={{
                border: "1px solid #bfcbe1",
                borderRadius: "5px",
                width: "100%",
              }}
              className="mt-4"
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                className="mt-2"
              >
                <div className="ml-3">
                  <span style={{ fontSize: "18px", fontWeight: 500 }}>
                    Total Expenses
                  </span>
                  <br></br>
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#6e7491",
                      fontWeight: 500,
                    }}
                  >
                    Current FY vs Previous FY
                  </span>
                </div>
                <div className="mr-3">
                  <p
                    style={{ color: "#dd4433", cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/insights-advanced-summary/profit-loss/${client_code}#expenses`,
                        state: { client_code, company_name },
                      });
                    }}
                  >
                    View More
                  </p>
                </div>
              </div>
              <ReactECharts
                option={option}
                style={{
                  width: "100%",
                  position: "relative",
                  top: "10%",
                  bottom: "10%",
                }}
              />
              <div
                style={{
                  fontSize: "15px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                className="d-flex mt-3 mb-2"
              >
                <div
                  className="mr-2"
                  style={{
                    width: "16px",
                    height: "16px",
                    backgroundColor: "#e7733e",
                  }}
                ></div>
                &nbsp;
                <span>Current FY</span>
                &nbsp;
                <div
                  className="ml-3"
                  style={{
                    width: "16px",
                    height: "16px",
                    backgroundColor: "#7c8db0",
                  }}
                ></div>
                &nbsp;
                <span className="ml-2">Previous FY</span>
              </div>
            </div>
          ) : (
            <div
              style={{
                border: "1px solid #bfcbe1",
                borderRadius: "5px",
                width: "100%",
                height: "300px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "4%",
              }}
            >
              <div>
                <h1>No Expenses Data Found!</h1>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.insightsAdvanced.totalExpenseFetching,
  totelExpense: state.insightsAdvanced.totelExpense,
  currency: state.auth.currencySign,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchInsightsAdvancedExpenseListData: (data: InsightsAdvancedPayload) =>
    dispatch(getInsightsAdvancedExpenseAction(data)),
  dispatchResetTotalExpenses: () => dispatch(resetTotalExpenses()),
});
export default connect(mapStateToProps, mapDispatchToProps)(TotalExpense);
